export const getCompletionColor = (completion?: number) => {
    if (completion === undefined || completion === 0) {
        return '#6B7280'; // not started 
    }
    if (completion === 100) {
        return '#059669'; // completed
    }
    return '#D97706'; // in progress
};

export const getImpactingDependencies = (dependencies: any, simFlag: boolean) => {
    const list: { project_id: any; name: any; impact: number; }[] = [];

    dependencies.forEach((dep: any) => {
        const rawImpact = simFlag ? dep?.sim_impact : dep?.impact;
        const impact = Number(rawImpact);

        if (Number.isFinite(impact) && impact > 0) {
            list.push({
                project_id: dep?.project_id ?? dep?.id,
                name: dep?.project_name ?? dep?.name,
                impact
            });
        }
    });

    return list;
}

export const getAcceleratingDependencies = (dependencies: any, simFlag: boolean) => {
    const list: { project_id: any; name: any; impact: number; }[] = [];

    dependencies.forEach((dep: any) => {
        const rawImpact = simFlag ? dep?.sim_impact : dep?.impact;
        const impact = Number(rawImpact);

        if (Number.isFinite(impact) && impact < 0) {
            list.push({
                project_id: dep?.project_id ?? dep?.id,
                name: dep?.project_name ?? dep?.name,
                impact: Math.abs(impact)
            });
        }
    });

    return list;
}

export const numberWithCommas = (x: any) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const getCompletionStyles = (completion?: number, colorOverride?: string) => {
    const baseColor = colorOverride || getCompletionColor(completion);
    return {
        background: `linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.3)), ${baseColor}`,
        border: `1px solid ${baseColor}`,
        boxShadow: `0 1px 3px ${baseColor}50`,
        padding: '0px 4px',
        fontSize: '10px',
        minWidth: '28px',
        height: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    };
}; 

export const getDependencyImpactValue = (dep: any, useSimulation: boolean): number => {
    const raw = useSimulation ? dep?.sim_impact : dep?.impact;
    const impact = Number(raw);
    return Number.isFinite(impact) ? impact : 0;
};

export const getImpactColorFromNumber = (impact: number): string => {
    return impact > 0 ? '#dc2626' : '#166534';
};

export const hasAnyPositiveImpact = (dependencies: any[], useSimulation: boolean): boolean => {
    if (!Array.isArray(dependencies)) return false;
    return dependencies.some((dep) => getDependencyImpactValue(dep, useSimulation) > 0);
};

/**
 * Get Tailwind CSS classes for priority badge styling
 * @param priority - Priority value (string, number, null, or undefined)
 * @returns Tailwind CSS classes for the priority badge
 */
export const getPriorityColorClasses = (priority: string | number | null | undefined): string => {
    if (!priority) return '';
    const priorityStr = String(priority).toLowerCase();
    const priorityNum = Number(priority);
    
    if (priorityNum === 1 || priorityStr === 'high' || priorityStr === '1') {
        return 'bg-red-100/70 text-red-700 dark:bg-red-900/30 dark:text-red-300';
    } else if (priorityNum === 2 || priorityStr === 'medium' || priorityStr === '2') {
        return 'bg-orange-100/70 text-orange-700 dark:bg-[#561212ba] dark:text-orange-300';
    } else {
        return 'bg-gray-100/70 text-gray-600 dark:bg-gray-700/50 dark:text-gray-300';
    }
};